<template>
    <div class="item">
        <a href="" target="_blank">
            <img :src="cover" alt="">
            <div class="left-over">
                <div class="inner">
                    <div class="tit1">{{name}}</div>
                    <div class="button">
                        <span class="l-btn1">{{tag}}</span></div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
    export default {
        name: "EiBookItem",
        props:{
            cover:{
                type:String,
                default:'/upload/book/s5c3592a5edbf6.jpg'
            },
            name:{
                type:String,
                default:'书籍名称'
            },
            tag:{
                type:String,
                default:'书籍标签'
            }
        }
    }
</script>

<style scoped lang="scss">
    .item {
        float: left;
        width: 300px;
        height: 410px;
        overflow: hidden;
        margin-left: 1.3%;
        margin-bottom: 1%;
        position: relative;

        img{
            width: 100%;
        }
    }

    .item .left-over {
        position: absolute;
        left: 0;
        top: 0;
        width: 116px;
        height: 100%;
        background: #BB956A;
        color: #fff;
        font-size: 16px;
        opacity: 0;
        transition: all .4s ease
    }

    .item:hover .left-over {
        opacity: 1
    }

    .item .left-over .inner {
        padding: 70px 10px 0;
        writing-mode: tb-rl;
        width: 94px;
        max-width: 116px;
        margin: 0 auto
    }

    .item .left-over .button {
        font-size: 14px;
        margin-right: 12px
    }

    .item .left-over .button span {
        display: inline-block;
        padding: 20px 3px;
        border-radius: 3px;
        margin-bottom: 18px
    }

    .item .left-over .button .l-btn1 {
        background: #771d1c
    }

    .item .left-over .button .l-btn2 {
        background: #2e2824
    }
</style>
